import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { Fields, N06MainFooter } from './N06MainFooter.types';
import { Footer, FooterProps, SvgIconType } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

interface N06MainFooterProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: Fields;
}

export const Default = (props?: N06MainFooterProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const { renderRichText, renderText, renderImage, renderLink } = useConditionalRendering();
  const model: N06MainFooter | undefined = props?.fields?.data?.footer;

  if (!model) {
    if (isEditing) {
      return <h3>Data source for rendering {props?.rendering?.componentName} is not set</h3>;
    }
    return <></>;
  }

  if (model.copyrightText?.jsonValue?.value) {
    model.copyrightText.jsonValue.value = model.copyrightText.jsonValue.value.replace(
      /{year}/,
      new Date().getFullYear().toString()
    );
  }

  const footerArgs: FooterProps = {
    logo: renderImage(model?.logo?.jsonValue),
    logoLink: renderLink(model?.logoLink?.jsonValue, { required: true }),
    socialMediaLinks: model.socialMediaLinks?.targetItems?.map((item) => {
      const link = item?.link?.jsonValue?.value;
      const socialMediaType = item?.type?.jsonValue?.fields?.Value?.value as SvgIconType;
      const socialMediaTitle = item?.type?.jsonValue?.fields?.Key?.value;

      return {
        link: (
          <a
            href={`${link?.href}`}
            target={`${link?.target}`}
            title={`${socialMediaTitle}`}
            aria-label={`${socialMediaTitle}`}
          />
        ),
        iconName: socialMediaType,
      };
    }),
    bottomText: renderRichText(model?.bottomRichText?.jsonValue),
    legalSection1Text: renderRichText(model?.legalSection1Copy?.jsonValue),
    copyRightText: renderText(model?.copyrightText?.jsonValue),
    legalSection2Text: renderRichText(model?.legalSection2Copy?.jsonValue),
    footerColumn:
      model?.footerColumns?.results?.map((footerColumn) => {
        return {
          headline: renderText(footerColumn?.heading?.jsonValue),
          footerLinkItems:
            footerColumn?.footerLinkItems?.results?.map((footerLinkItem) => {
              return renderLink(footerLinkItem?.link?.jsonValue);
            }) ?? [],
        };
      }) ?? [],
  };

  return <Footer data-elastic-exclude="" {...footerArgs} />;
};
